<template>
  <div
    class="border mt-1 rounded-2xl max-h-[90vh] p-2 text-xl min-w-[32.7%] mx-1"
    :class="[
      totalAmount ? 'bg-[#E5F4F3] border-[#009285]' : '',
      totalCosts ? 'bg-[#F5E4E4] border-[#B45A5A]' : '',
      totalServices ? 'bg-[#F5F3E4] border-[#B4955A]' : ''
    ]"
  >
    <h1
      class=""
      :class="[
        totalAmount ? 'text-[#009285]' : '',
        totalCosts ? 'text-[#B45A5A]' : '',
        totalServices ? 'text-[#B49B5A]' : ''
      ]"
    >
      <span>
        {{ props.value }}
      </span> <br>
      {{ props.label }}
    </h1>
  </div>
</template>

<script setup>
const props = defineProps({
  label: String,
  value: [String, Number],
  totalAmount: { Boolean, default: false },
  totalCosts: { Boolean, default: false },
  totalServices: { Boolean, default: false }
})

</script>
